import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import {
  metersToFeet,
  getFormattedNumber,
  getFiberSetupDiagram,
  isNaviTEKType
} from '../../../../../../../../common/utils'
import Status from '../status'

class FiberLengthLossLengthTable extends React.Component {
  constructor(props) {
    super(props)
  }

  lengthUnitConverter = (length) => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    let formattedNum = getFormattedNumber(length)
    return (formattedNum) ? parseFloat(formattedNum) : 0
  }
  render() {
    const {
      showFiberQualificationResults,
      verifyLength,
      fiberTestSetup,
      fiberLengthData,
      translate,
      classes,
      chartMeasurementUnit,
      job
    } = this.props

    let isNavitek = job && isNaviTEKType(job.deviceid);

    const measurementUnit = chartMeasurementUnit === 'feet' ? "" : ` (${translate('m')})`
    const mode = fiberTestSetup && fiberTestSetup.fibertype && fiberTestSetup.fibertype.startsWith("OS") ? "SM" : "MM";
    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {!showFiberQualificationResults && <TableCell>{translate('fiber_verify_length')}</TableCell>}
            {isNavitek && <TableCell>{translate('test_setup')}</TableCell>}
            <TableCell numeric>{translate('fiber_refractiveindex')}</TableCell>
            <TableCell numeric>{translate('fiber_length')}{measurementUnit}</TableCell>
            {!isNavitek && <TableCell numeric>{translate('fiber_lengthlimit')}{measurementUnit}</TableCell>}
            {!isNavitek && <TableCell numeric>{translate('fiber_lengthmargin')}{measurementUnit}</TableCell>}
            <TableCell numeric>{translate('fiber_result')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow >
            {!showFiberQualificationResults && <TableCell>{verifyLength ? translate('enabled') : translate('disabled')}</TableCell>}
            {isNavitek && <TableCell><img className={classes.fiberQualImage} alt="" src={getFiberSetupDiagram(mode, fiberTestSetup.singlefiber, isNavitek)}/></TableCell>}
            <TableCell numeric>{fiberLengthData.refractiveindex}</TableCell>
            <TableCell numeric>{(fiberLengthData.cablelength !== null) ? this.lengthUnitConverter(fiberLengthData.cablelength) : (translate('general_na'))}</TableCell>
            {!isNavitek && <TableCell numeric>{fiberLengthData.lengthlimit === null ? "-" : this.lengthUnitConverter(fiberLengthData.lengthlimit)}</TableCell>}
            {!isNavitek && <TableCell numeric>{fiberLengthData.lengthmargin === null ? "-" : this.lengthUnitConverter(fiberLengthData.lengthmargin)}</TableCell>}
            <TableCell numeric>{fiberLengthData.teststatus ? (<React.Fragment> <Status status={fiberLengthData.teststatus} /></React.Fragment>) : (translate('general_na'))}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(FiberLengthLossLengthTable)

